export const dedupeStylesheets = (): void => {
  const seen = new Set<string>();

  for (const link of document.querySelectorAll<HTMLLinkElement>('link[rel="stylesheet"]')) {
    if (!seen.has(link.href)) {
      seen.add(link.href);
      continue;
    }

    if (link.sheet) link.remove();
    else link.addEventListener('load', () => link.remove(), { once: true });
  }
};

export const watchDuplicateStylesheets = (): void => {
  dedupeStylesheets();
  new MutationObserver(dedupeStylesheets).observe(document.head, { childList: true });
};
